module.exports = __webpack_public_path__ + "static/semplicita.medium-d734707b71ad48d74c43c37f8dc41632.otf";